//import axios, { AxiosInstance, AxiosRequestConfig } from "axios";
import { IChatRequest, IChatEvalRequest } from "../interfaces/chatBotInterfaces";
import { IChatBotApi } from "../interfaces/apiInterface";
import { useChatBotStore } from "../stores/chatBotStore";

export class ChatBotApi implements IChatBotApi {
  //public readonly axios: AxiosInstance;

  constructor(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private api: any,
    private baseURL: string
  ) {
    //logEvent(`Initializing`, "UnifiedPortalAPI", this.upEndpoint);
    // this.axios = axios.create({
    //   withCredentials: true,
    //   withXSRFToken: false,
    //   allowAbsoluteUrls: false,
    // });
  }

  // private send = async <T = any>(request: AxiosRequestConfig) => {
  //   return this.axios.request<T>(request);
  // };

  // public ask(request: IChatRequest) {
  //   return this.send({
  //     method: "POST",
  //     url: `${this.apiURL}/api/v1/chat`,
  //     data: request,
  //   } as AxiosRequestConfig);
  // }

  public async ask(request: IChatRequest) {
    return await this.api.ask(request);
  }

  public async chatEval(request: IChatEvalRequest) {
    return await this.api.chatEval(request);
  }

  public async askStream(request: IChatRequest) {
    const chatBotStore = useChatBotStore();
    try {
      chatBotStore.requestFailed = false; // Reset requestFailed before sending a new message
      const cookies = document.cookie.split(";");

      let token = "";
      for (const c of cookies) {
        const split = c?.split("=");
        if (split[0].trim() === "XSRF-TOKEN") {
          token = split[1];
          break;
        }
      }

      const result = await fetch(`${this.baseURL}/api/v1/chat/stream`, {
        method: "POST",
        credentials: "include", // Sends cookies if set
        headers: { "Content-Type": "application/json", "X-XSRF-TOKEN": token },
        body: JSON.stringify(request),
      }).catch(error => {
        console.error("Error during fetch:", error);
        chatBotStore.requestFailed = true;
        chatBotStore.isLoading = false;
      });

      if (!result || result.status !== 200 || !result.body) {
        console.error("No response body received.");
        chatBotStore.requestFailed = true;
        chatBotStore.isLoading = false;
        return;
      }

      return result;
    } catch (error) {
      console.error("Error during streaming:", error);
      chatBotStore.requestFailed = true;
      chatBotStore.isLoading = false;
    }
  }
}

// fetch("https://api.example.com/streaming-data")
//   .then(response => {
//     const reader = response.body.getReader();
//     const decoder = new TextDecoder("utf-8");
//     return reader.read().then(function processResult({ done, value }) {
//       if (done) {
//         console.log("Stream complete");
//         return;
//       }
//       const chunk = decoder.decode(value, { stream: true });
//       const data = JSON.parse(chunk);
//       console.log("Received:", data);
//       return reader.read().then(processResult);
//     });
//   })
//   .catch(err => console.error("Error:", err));
